import { useMutation } from '@tanstack/react-query';

import { FetchDroneHarmonyFlightPlanResponse } from '../../../../../../../../typings/api/skymap/rest/v1/project';
import { SkyMapAxiosServiceFactory } from '../../../../../../services/axios/skymap-axios-service-factory';

type FetchFlightPlansProps = {
  projectId: string;
  onError: (error: Error) => void;
  onMutate: (payload: FetchDroneHarmonyFlightPlanResponse) => void;
};

type RemoveIntegrationProps = {
  projectId: string;
  onError: (error: Error) => void;
  onMutate: () => void;
};

type RemoveFlightPlanProps = {
  projectId: string;
  flightPlanId: string;
  onError: (error: Error) => void;
  onMutate: () => void;
};

const useFetchFlightPlansQuery = (props: FetchFlightPlansProps) =>
  useMutation({
    mutationFn: async () => {
      return await SkyMapAxiosServiceFactory.instance
        .createProjectServiceV1()
        .fetchDroneHarmonyFlightPlans({
          path: {
            projectId: props.projectId,
          },
        });
    },
    retry: false,
    networkMode: 'always',
    onError: (err, variables, context) => props.onError(err),
    onSuccess: (data: FetchDroneHarmonyFlightPlanResponse, variables: void, context: unknown) =>
      props.onMutate(data),
  });

const useRemoveIntegrationQuery = (props: RemoveIntegrationProps) =>
  useMutation({
    mutationFn: async () => {
      return await SkyMapAxiosServiceFactory.instance
        .createProjectServiceV1()
        .removeDroneHarmonyIntegration({
          path: {
            projectId: props.projectId,
          },
        });
    },
    retry: false,
    networkMode: 'always',
    onError: (err, variables, context) => props.onError(err),
    onSuccess: (data: void, variables: void, context: unknown) => props.onMutate(),
  });

const useRemoveFlightPlanQuery = (props: RemoveFlightPlanProps) =>
  useMutation({
    mutationFn: async () => {
      return await SkyMapAxiosServiceFactory.instance
        .createProjectServiceV1()
        .deleteDroneHarmonyFlightPlan({
          path: {
            projectId: props.projectId,
            flightPlanId: props.flightPlanId,
          },
        });
    },
    retry: false,
    networkMode: 'always',
    onError: (err, variables, context) => props.onError(err),
    onSuccess: (data: void, variables: void, context: unknown) => props.onMutate(),
  });

export { useFetchFlightPlansQuery, useRemoveFlightPlanQuery, useRemoveIntegrationQuery };
